if (!customElements.get('steadia-review-carousel')) {
  customElements.define('steadia-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const track = this.querySelector('[data-track]');
      const originals = [...track.children];
      const count = originals.length;
      if (count < 2) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const clone = card => {
        const copy = card.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.removeAttribute('data-shopify-editor-block');
        copy.dataset.loopCopy = 'true';
        return copy;
      };
      track.prepend(...originals.map(clone));
      track.append(...originals.map(clone));
      this.querySelector('.src-arrows').hidden = false;
      let span = 0, step = 0, target = 0, resetting = false, index = 0, navigating = false, measuredWidth = 0;
      const jump = left => {
        resetting = true;
        track.classList.add('is-resetting');
        track.scrollLeft = left;
        target = left;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          track.classList.remove('is-resetting');
          resetting = false;
        }));
      };
      const measure = () => {
        if (!track.clientWidth || track.clientWidth === measuredWidth) return;
        measuredWidth = track.clientWidth;
        step = originals[1].getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
        span = step * count;
        navigating = false;
        jump(span + index * step);
      };
      const settle = () => {
        if (resetting || (navigating && Math.abs(track.scrollLeft - target) > 2)) return;
        navigating = false;
        let left = track.scrollLeft;
        while (left < span - 1) left += span;
        while (left >= 2 * span - 1) left -= span;
        index = ((Math.round((left - span) / step) % count) + count) % count;
        if (Math.abs(left - track.scrollLeft) > 1) jump(left);
        else target = span + index * step;
      };
      const advance = direction => {
        if (!span) return;
        clearTimeout(this.timer);
        let left = target;
        while (left < span - 1) left += span;
        while (left >= 2 * span - 1) left -= span;
        const shift = left - target;
        if (Math.abs(shift) > 1) jump(track.scrollLeft + shift);
        target = left + direction * step;
        index = ((Math.round((target - span) / step) % count) + count) % count;
        navigating = true;
        track.scrollTo({left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        this.querySelector('[data-status]').textContent = this.dataset.statusTemplate.replace('__CURRENT__', index + 1);
      };
      track.addEventListener('scroll', () => {
        if (resetting) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(settle, 160);
      }, {signal});
      track.addEventListener('scrollend', settle, {signal});
      ['pointerdown', 'touchstart', 'wheel'].forEach(event => track.addEventListener(event, () => {
        navigating = false;
        target = track.scrollLeft;
      }, {passive: true, signal}));
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        advance(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      this.querySelectorAll('[data-slide]').forEach(button => button.addEventListener('click', () => advance(Number(button.dataset.slide)), {signal}));
      this.observer = new ResizeObserver(measure);
      this.observer.observe(track);
      measure();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.querySelectorAll('[data-loop-copy]').forEach(card => card.remove());
    }
  });
}
